import React, { useEffect, useState } from "react";
import "../../styles/faculty/main.css";
import { Link } from "react-router-dom";
import { getAllFaculty } from "../../Services/AllAPIs";
import LoadingSpinner from "../LoadingSpinner";

const Main = () => {
    const [loader, setLoader] = useState(true);
    const [faculty, setFaculty] = useState([]);
    const [error, setError] = useState(null);

    const getFaculty = () => {
        getAllFaculty()
            .then((res) => {
                // Convert the faculty object to an array
                const facultyData = Object.values(res.data.faculty);
                console.log("Faculty Data:", facultyData);
                setFaculty(facultyData);
                setLoader(false);
            })
            .catch((error) => {
                console.error("Error fetching faculty:", error);
                setError("An error occurred while fetching faculty data.");
                setLoader(false);
            });
    };

    useEffect(() => {
        getFaculty();
    }, []);

    return (
        <>
            <div className="faculties pt-5">
                <div className="py-4">
                    <div className="container">
                        <h2
                            className="my-heading"
                            style={{ paddingLeft: 10, color: "black" }}
                        >
                            FACULTIES
                        </h2>
                        <p
                            className="text-left"
                            style={{ paddingLeft: 10, paddingRight: 35, color: "black" }}
                        >
                            Chaudhary Charan Singh University (CCSU), formerly known as Meerut
                            University, is a renowned institution in India offering a diverse
                            range of academic disciplines through its various faculties.
                        </p>
                        <div className="cards-main">
                            {loader && <LoadingSpinner />}
                            {error && <div className="error">{error}</div>}
                            {faculty.length > 0 ? (
                                faculty.map((facultyItem) => (
                                    <div className="card" key={facultyItem.id}>
                                        <Link to={`/faculty/${facultyItem.url_id}`}>
                                            <img
                                                src={facultyItem.logo}
                                                alt={facultyItem.name}
                                            />
                                            <h6 className="card-title">{facultyItem.name}</h6>
                                        </Link>
                                    </div>
                                ))
                            ) : (
                                <div>No faculty available at the moment. Please check back later.</div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Main;
